<template>
  <div class="filling-goods-div">
    <div style="padding-top: 5px; font-size: 16px">待拣货列表</div>
    <div class="order-goods-head">
      <div class="order-head-div">
        <div class="time-input-div">
          <input class="time-input" placeholder="开始时间" @click="DatePicker(0)" v-model="startDate" readonly="readonly"
            type="datetime" />
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker v-model="tempDate" type="datetime" @confirm="hideDatePicker"
              @cancel="cancelDatePicker"></van-datetime-picker>
          </van-popup>
        </div>
        <div class="time-input-div">
          <input class="time-input" placeholder="结束时间" @click="DatePicker(1)" v-model="endDate" readonly="readonly"
            type="datetime" />
        </div>
      </div>
      <div class="order-head-div">
        <div class="time-input-div">
          <!-- <div style="width: 50%; text-align: left">供应商:</div> -->
          <input class="time-input" placeholder="搜索订单号" v-model="order_number" @keyup.enter="SearchOrder()" />
        </div>
        <div class="time-input-div">
          <input class="time-input" placeholder="搜索货号" name="normsware" v-model="goods_number"
            @keyup.enter="SearchGoods()" />
        </div>
      </div>
      <div class="order-head-div">
        <div class="time-input-div">
          <input class="time-input" placeholder="搜索客户" v-model="client" @keyup.enter="SearchOrder()" />
        </div>
        <div class="time-input-div" style="width:155px">
        </div>
      </div>
    </div>

    <span style="color: red" v-if="hostcs">测试服</span>
    <!-- <div
        style="display: flex; justify-content: space-between; align-items: center"
        v-if="outNumber === '未出库'"
      >
      </div> -->
    <div :style="style" @scroll="onScroll">
      <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"> -->
      <!-- <div class="order-mx" v-for="(i, index) in data" :key="index" @click="go_pick(index)"> -->
      <div class="order-mx" v-for="(i, index) in data" :key="index">
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.order_number) }">
          <div style=" text-align: left">订单号:{{ i.order_number }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.affirm_time) }">
          <div style=" text-align: left">订单日期:{{ i.affirm_time }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.goods_number) }">
          <div style=" text-align: left;text-decoration: underline; cursor: pointer;" @click="showGoods(i.goods_number)">货号:{{ i.goods_number }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.order_shop) }">
          <div style=" text-align: left">客户:{{ i.order_shop }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.pi) }">
          <div style=" text-align: left">匹数:{{ i.ps }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.yjhps) }">
          <div style=" text-align: left">已拣货匹数:{{ i.yjhps }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.mf) }">
          <div style=" text-align: left">门幅:{{ i.mf }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.goods_name) }">
          <div style=" text-align: left">产品名称:{{ i.goods_name }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.goods_normtype) }">
          <div style=" text-align: left">规格:{{ i.goods_normtype }}</div>
        </div>
        <div class="info-data-p" :class="{ 'full-width': shouldUseWidth(i.mx_remark) }">
          <div style=" text-align: left">备注:{{ i.mx_remark }}</div>
        </div>
        <div class="info-data-p">
        </div>
        <div class="info-data-p" style="justify-content: flex-end;">
          <van-button type="primary" style=" height: 30px; line-height: 28px; margin-right: 20px;" @click="go_pick(index)">拣货</van-button>
          <van-button type="danger" style=" height: 30px; line-height: 28px;" @click="Outstock(i.id)">缺货</van-button>
        </div>
      </div>
      <div v-if="!finished" style="font-size: 16px;color: #b9b9b9;align-items: center;padding: 10px;text-align: center;">
        没有更多了</div>
      <!-- </van-list> -->
    </div>
    <div class="filling-bottom-button" style="display: flex">
      <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
    </div>
  </div>
</template>
  
<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import { DatetimePicker } from 'vant';
import moment from 'moment';
export default {
  name: "orderDetailsList",
  data() {
    return {
      hostcs: false,
      ray: "扫描中",
      id: "",
      style: "",
      reeldata: "",
      infoType: "1111",
      outNumber: "未出库",
      username: "",
      type: "orderInfo",
      //xin
      lizi: [],
      isDate: 0,
      showPicker: false,
      startDate: '',
      endDate: '',
      tempDate: new Date(),
      goods_number: "",
      order_number: "",
      client:"",
      list: [],
      data: [],
      maxByteLength: 30,
      loading: false,
      finished: true,
      page: 1
    };
  },
  mounted() {
    this.username = JSON.parse(window.localStorage.getItem("userinfo"));
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;max-height: " + h * 0.66 + "px;overflow: scroll;";
    //   setTimeout(() => {      }, 500);
    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }
    this.Order();
  },
  computed: {
    shouldUseWidth() {
      return (value) => {
        const encoder = new TextEncoder();
        const bytes = encoder.encode(value);
        const byteLength = bytes.length;
        //console.log(value,bytes.length)
        return byteLength > this.maxByteLength;
      };
    }
  },
  methods: {
    onScroll(e) {  //下拉加载数据
      const bottomOfList = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
      if (bottomOfList && this.finished) {
        this.Order();
      }
    },
    DatePicker(index) {
      this.showPicker = true;
      this.isDate = index;
    },
    cancelDatePicker() {
      this.showPicker = false;
    },
    hideDatePicker() {
      this.showPicker = false;
      if (this.isDate) {
        this.endDate = moment(this.tempDate).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.startDate = moment(this.tempDate).format('YYYY-MM-DD HH:mm:ss');
      };
      //进行时间判断，符合条件开始筛选
      if (this.endDate < this.startDate && this.endDate !== '') {
        Dialog.alert({
          message: "开始时间不能大于结束时间!",
        });
        this.endDate = '';
      } else {
        this.page = 1;
        this.data = [];
        this.Order();
      }
    },
    async Order() {
      //this.finished = false;
      await this.get(this.APIOBJ.searchOrder, {
        start_time: this.startDate,
        end_time: this.endDate,
        order_number: this.order_number,
        goods_number: this.goods_number,
        client: this.client,
        page: this.page
      }).then(
        (res) => {
          if (res.data.status == 1) {
            this.list = res.data.data.goodsorder.data;
            this.list.map((i) => {
              this.data.push(i)
            })
            if (this.list.length === 0) {
              this.finished = false;
            } else {
              this.page++;
              this.finished = true;
            }
          } else { Toast(res.data.msg); }
        }
      )
    },
    async Outstock(id){
      await this.get(this.APIOBJ.Outstock, {
          id:id
      }).then(
        (res) => {
          if (res.data.status == 1) {
            Toast(res.data.msg);
          } else { Toast(res.data.msg); }
        }
      )
    },
    SearchOrder() {
      this.data = [];
      this.page = 1;
      this.Order();
    },
    SearchGoods() {
      this.data = [];
      this.page = 1;
      this.Order();
    },
    showGoods(i){
      this.$router.push({ path: "/NumberFind", query: { name: i } });
    },
    // onLoad() {
    //   // 异步更新数据
    //   console.log('ss+', this.data.length, this.page)
    //   setTimeout(() => {
    //     this.page++
    //     this.loading = false;
    //     this.SearchOrder()
    //     // 加载状态结束
    //   }, 1000);
    // },
    go_pick(i) {
      this.$router.push({ path: "/FabricPicking", query: { data: this.data[i] } });
    },
    // gourl(url) {
    //   url = "http://www.lcyjfz.com/home/scan?url=" + url;
    //   window.location.href = url;
    // },
    go_index() {
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },
  },
};
</script>
  
<style lang="less">
@import "../style/outOrderInfo.less";

.info-data-p {
  display: flex;
  padding: 0px 0px 10px 0px;
  align-items: center;
  //justify-content: center;
  width: 50%;
}

.filling-bottom-button {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin-left: -10px;
}

.order-head-div {
  display: flex;
  width: 100%;
  padding: 5px 0;
  justify-content: space-around;
}

.order-goods-head {
  padding: 20px 0;
}

.time-input-div {
  display: flex;
  /* width: 100%; */
  align-items: center;
  position: relative;
}

.time-input {
  width: 100%;
  text-align: center;
}

.time-input::placeholder {
  text-align: center;
}

.order-mx {
  padding: 3%;
  border-bottom: 1px solid #444444;
  display: flex;
  flex-wrap: wrap;
}

.full-width {
  width: 100%;
}
</style>